<template>
  <a-table :columns="columns" :data-source="data" bordered>
    <template
      v-for="col in ['name', 'code', 'value','proportion']"
      :slot="col"
      slot-scope="text, record, index"
    >
      <div :key="col">
        <a-input-number  :min="0" style="margin: -5px 0"  :value="text" @change="e => handleChange(e, record.key, col)" />
        <!-- <a-input
          
          style="margin: -5px 0"
          :value="text"
          @change="e => handleChange(e.target.value, record.key, col)"
        /> -->

      </div>
    </template>

  </a-table>
</template>
<script>
import { httpAction, getAction } from '@/api/manage'
export default {
  data() {
    
    return {
      
      data:[],
      columns:[
              {
                title: '名称',
                dataIndex: 'name',
                width: '25%',
              },
              {
                title: '编码',
                dataIndex: 'code',
                width: '15%',
              },
              {
                title: '数值',
                dataIndex: 'value',
                width: '20%',
                scopedSlots: { customRender: 'value' },
              },
              {
                title: '占比',
                dataIndex: 'proportion',
                width: '20%',
                // scopedSlots: { customRender: 'proportion' },
              }
            ],
      editingKey: '',
      mockId:'',
      id:'',
      url: {
          sublist: "/sys/sysapimockvalue/list",
          edit: "/sys/sysapimockvalue/edit"
        },
    };
  },
  methods: {
    csh(record){
      let that = this;
      this.mockId = record.id;
      
      httpAction(this.url.sublist+"?mockId="+record.id,null,'get').then((res)=>{
        if(res.success){
          var mockJsonStr = res.result[0].mockDataJson;
          this.id = res.result[0].id;
          this.data = JSON.parse(mockJsonStr);
            for (let i = 0; i < this.data.length; i++) {
              this.data[i].key = i.toString();
            }
            this.cacheData = this.data.map(item => ({ ...item }));
        }else{
          that.$message.warning(res.message);
        }
      }).finally(() => {
      })
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }

      let zs = 0;//总数
      for (let i = 0; i < this.data.length; i++) {
        if(this.data[i].value!=null&&this.data[i].value!=''&&this.data[i].value!=undefined){
          zs = zs + parseFloat(this.data[i].value);
        }else{
          this.data[i].value = 0;
        }
      }
      if(zs!=0){
        for (let i = 0; i < this.data.length; i++) {
          this.data[i].proportion = (this.data[i].value/zs*100).toFixed(2)+'%';
        }
      }
    },
    
    submitForm () {
        const that = this;
        let formData = {};
        formData.id = this.id;
        formData.mockId = this.mockId;
        var mockJsonStr = JSON.stringify(this.data);
        formData.mockDataJson = mockJsonStr;
        
        httpAction(that.url.edit,formData,'put').then((res)=>{
        if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
        
      },
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>
